import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {HTTPAssistantRepository} from '../Repositories/HTTPAssistantRepository.js'
import {UpdateAssistantChatRequest} from '../Requests/UpdateAssistantChatRequest.js'

class UpdateAssistantChatUseCase extends UseCase {
  #assistantRepository

  constructor({assistantRepository}) {
    super()
    this.#assistantRepository = assistantRepository
  }

  static create({config}) {
    return new UpdateAssistantChatUseCase({
      assistantRepository: HTTPAssistantRepository.create({config})
    })
  }

  @tracer({metric: 'UpdateAssistantChatUseCase#execute'})
  @AsyncInlineError()
  async execute({chatId, text, context, variant}) {
    const updateAssistantChatRequest = UpdateAssistantChatRequest.create({chatId, text, context})
    const [error, response] = await this.#assistantRepository.updateChat({updateAssistantChatRequest, variant})
    if (error) return Promise.reject(error)
    return response?.toJSON?.()
  }
}

export const factory = UpdateAssistantChatUseCase.create
